export const quickstartAppTypeMap = {
  'Single-Page App': 'spa',
  'Regular Web App': 'webapp',
  'Backend/API': 'backend',
  'Native/Mobile App': 'native',
};

export const quickstartDescriptionMap = {
  'JavaScript web app that runs in the browser': 'spa',
  'Traditional web app that runs on the server': 'webapp',
  'An API or service protected by Auth0': 'backend',
  'Mobile or Desktop app that runs natively on a device': 'native',
};
